export const CENTROS = [
  { id: 1, key: 'azcuenaga4b', label: 'Azcuénaga 4B' },
  { id: 2, key: 'azcuenaga2b', label: 'Azcuénaga 2B' },
  { id: 3, key: 'lobos', label: 'Lobos' },
];

export const CATEGORIAS_GASTOS = {
  azcuenaga4b: [
    { id: 1, nombre: 'Alquiler Azcuénaga 4B' },
    { id: 2, nombre: 'Expensas 4B' },
    { id: 3, nombre: 'Internet 4B' },
    { id: 4, nombre: 'Metrogas 4B' },
  ],
  azcuenaga2b: [
    { id: 5, nombre: 'Alquiler Azcuénaga 2B' },
    { id: 6, nombre: 'Expensas 2B' },
    { id: 7, nombre: 'Internet 2B' },
    { id: 8, nombre: 'Metrogas 2B' },
  ],
  lobos: [
    { id: 9, nombre: 'Alquiler Lobos' },
    { id: 10, nombre: 'Internet Lobos' },
    { id: 11, nombre: 'Gas Lobos' },
    { id: 12, nombre: 'Lavandería Lobos' },
    { id: 13, nombre: 'Productos de limpieza Lobos' },
  ],
  compartidos: [
    { id: 14, nombre: 'Productos de Limpieza Azcuénaga' },
    { id: 15, nombre: 'Insumos' },
    { id: 16, nombre: 'Sensores y accesorios' },
    { id: 17, nombre: 'Honorarios Programación' },
    { id: 18, nombre: 'Honorarios Empleados' },
    { id: 19, nombre: 'Honorarios contador' },
    { id: 20, nombre: 'Honorarios Dras Blatter/Diaz/Portinari/Médica/Médico' },
    { id: 21, nombre: 'Honorarios reparaciones y mejoras Azcuénaga' },
    { id: 22, nombre: 'Honorarios reparaciones y mejoras Lobos' },
  ],
};

export const GRUPOS_ORDEN = ['azcuenaga4b', 'azcuenaga2b', 'lobos', 'compartidos'];

export const GRUPOS_LABELS = {
  azcuenaga4b: 'Azcuénaga 4B',
  azcuenaga2b: 'Azcuénaga 2B',
  lobos: 'Lobos',
  compartidos: 'Gastos Compartidos',
};
